import { gql } from '@apollo/client'
import { POINT_OF_INTEREST_FRAGMENT } from '../fragments'

export const CREATE_PICOS_POI = gql`
  mutation CreatePicOSPOI($input: CreatePicOSPOIInput!) {
    createPicosPoi(input: $input) {
      picosPoi {
        ...PointOfInterest
      }
    }
  }
  ${POINT_OF_INTEREST_FRAGMENT}
`
